import BaseController from "./BaseController";
import JSONModel from "sap/ui/model/json/JSONModel";
import { ErrorHandler } from "../service/ErrorHandler.service";
import { EnvironmentService } from "../service/Environment.service";
import encodeURL from "sap/base/security/encodeURL";
import { SearchField$SearchEvent } from "sap/m/SearchField";
import { ListBase$ItemPressEvent, ListBase$SelectionChangeEvent, ListBase$UpdateFinishedEvent, ListBase$UpdateStartedEvent } from "sap/m/ListBase";
import { Artikel, Preis } from "../model/models";
import { Button$PressEvent } from "sap/m/Button";

/**
 * @namespace com.unitrade.crm.controller
 */
export default class ArticleList extends BaseController {
  public override async getTitle(): Promise<string> {
    return await this.getTranslatedString("ArticleSearch");
  }

  public async onInit(): Promise<void> {
    const oModel = new JSONModel();
    oModel.setProperty("/isUsingSlowDatabaseSearch", false);
    this.setModel(oModel);
  }

  protected onSearch = async (oEvent: SearchField$SearchEvent) => {
    const model = this.getModel() as JSONModel;
    model.setProperty("/artikel", []);
    const query = oEvent.getParameter("query");
    if (query && query.length > 1) {
      this._loadArtikel(query);
    }
  };

  private async _loadArtikel(search: string): Promise<void> {
    const model = this.getModel() as JSONModel;
    model.setProperty("/busy", true);
    jQuery.get(`${EnvironmentService.getBaseUrl()}/artikel/find/${encodeURL(search)}`).then(
      (newArticle: Artikel[], textStatus, jqXHR) => {
        const searchSource = jqXHR.getResponseHeader("x-source");
        if (searchSource === "Database") {
          model.setProperty("/isUsingSlowDatabaseSearch", true);
        } else {
          model.setProperty("/isUsingSlowDatabaseSearch", false);
        }

        model.setProperty("/artikel", newArticle);
        model.setProperty("/busy", false);
      },
      (fail) => {
        ErrorHandler.handleError(fail, { title: "Fehler bei der Artikelsuche", onRetry: () => this._loadArtikel(search) });
      }
    );
  }

  private _loadArtikelPreis(artid: number) {
    jQuery.get({
      url: `${EnvironmentService.getBaseUrl()}/artikel/${artid}/preis`,
      success: (data: Preis, textStatus, jqXHR) => {
        const model = this.getModel() as JSONModel;
        const artikelList = model.getProperty("/artikel") as Artikel[];
        const artikelIndex = artikelList.findIndex((art) => art.id === artid);
        model.setProperty("/artikel/" + artikelIndex + "/preis", data.gesamtPreisNetto);
        model.setProperty("/artikel/" + artikelIndex + "/preisMeasure", "EUR");
      },
    });
  }

  protected onListItemPress = (oEvent: ListBase$ItemPressEvent) => {
    const oItem = oEvent.getSource();
    const oBindingContext = oItem.getBindingContext();
    const oModel = oBindingContext.getModel();
    const id = oModel.getProperty("id", oBindingContext) as number;
    this.getOwnerComponent().getRouter().navTo("articleDetails", { idPath: id });
  };

  protected onSelection = (oEvent: ListBase$SelectionChangeEvent) => {
    const model = this.getModel() as JSONModel;
    model.setProperty(
      "/selectedItems",
      oEvent
        .getSource()
        .getSelectedContexts()
        .map((context) => context.getObject() as Artikel)
    );
  };

  protected compareButtonTextFormatter(arr: []) {
    const count = !arr ? 0 : arr.length;

    return `Vergleichen(${count})`;
  }

  protected compareVisibleFormatter(arr: []) {
    const count = !arr ? 0 : arr.length;

    return count > 1;
  }

  protected onComparePress = (oEvent: Button$PressEvent) => {
    const model = this.getModel() as JSONModel;
    const selectedArtikel = model.getProperty("/selectedItems") as Artikel[];
    const selectedArtikelIds = selectedArtikel.map((art) => art.id);
    const router = this.getOwnerComponent().getRouter();
    this.getOwnerComponent()
      .getRouter()
      .navTo("articleCompare", { idsPath: selectedArtikelIds.join(",") });
  };
}
